import React from 'react';
import { CustomizedTypography } from '@components/Customized';
import { RfqDetailData } from '@routes/Common/type';
import { Box, makeStyles } from '@material-ui/core';
import { useStylesCommon } from './useStyles';
import { requestEnumToString } from '@utils/enumToString';
import { CapaQuotationProductPurpose } from '@generated/graphql';
import { ConsultingStartMethodEnum } from './type';
import { formatCurrency } from '@utils/formatter';

const useStyles = makeStyles(() => {
  return {
    displayItem: {
      display: 'flex',
      '&:not(:first-child)': {
        marginTop: 8
      }
    },

    itemLabel: {
      minWidth: 90
    },
    itemContent: {
      display: 'flex'
    },
    itemTypography: {
      wordBreak: 'break-all'
    }
  };
});

interface Props {
  data?: RfqDetailData;
  matches?: boolean;
}

const RfqProjectInfoPresenter: React.FC<Props> = ({ data, matches }) => {
  const classes = useStyles({ matches: matches });
  const classesCommon = useStylesCommon({ matches: matches });
  const budgetOpen = data?.budgetOpen;
  const maxEstimatedBudget = data?.maxEstimatedBudget ?? 0;
  const projectName = data?.projectName;
  const projectPurpose = data?.projectPurpose;
  const projectPurposeDetail = data?.projectPurposeDetail;
  const consultingStartMethod = data?.consultingStartMethod;

  return (
    <Box className={classesCommon.root + ' item'}>
      <CustomizedTypography
        variant={'h4'}
        color="textPrimary"
        fontWeight="500"
        gutterBottoms={16}
      >
        프로젝트 정보
      </CustomizedTypography>
      <div className={classes.displayItem}>
        <CustomizedTypography
          className={classes.itemLabel}
          variant={'body1'}
          color="textSecondary"
          fontWeight="normal"
        >
          프로젝트명
        </CustomizedTypography>
        <CustomizedTypography
          variant={'body1'}
          color="textPrimary"
          fontWeight="normal"
        >
          {projectName}
        </CustomizedTypography>
      </div>
      <div className={classes.displayItem}>
        <CustomizedTypography
          className={classes.itemLabel}
          variant={'body1'}
          color="textSecondary"
          fontWeight="normal"
        >
          제품 용도
        </CustomizedTypography>
        <div>
          <CustomizedTypography
            variant={'body1'}
            color="textPrimary"
            fontWeight="normal"
            gutterBottom={!!projectPurposeDetail}
          >
            {projectPurpose !== CapaQuotationProductPurpose.Etc
              ? `${requestEnumToString(
                  projectPurpose as CapaQuotationProductPurpose
                )}`
              : '기타'}
          </CustomizedTypography>
          <CustomizedTypography
            variant={'body1'}
            color="textPrimary"
            fontWeight="normal"
            className={classes.itemTypography}
          >
            {projectPurposeDetail ? ` (${projectPurposeDetail})` : ''}
          </CustomizedTypography>
        </div>
      </div>
      <div className={classes.displayItem}>
        <CustomizedTypography
          className={classes.itemLabel}
          variant={'body1'}
          color="textSecondary"
          fontWeight="normal"
        >
          추정 예산
        </CustomizedTypography>
        {budgetOpen === true ? (
          maxEstimatedBudget > 0 ? (
            <div className={classes.itemContent}>
              <CustomizedTypography variant={'body1'} fontWeight="normal">
                {formatCurrency(maxEstimatedBudget) + '원'}
              </CustomizedTypography>
            </div>
          ) : (
            <CustomizedTypography variant={'body1'} fontWeight="normal">
              -
            </CustomizedTypography>
          )
        ) : (
          <CustomizedTypography variant={'body1'} fontWeight="normal">
            상담 후 협의
          </CustomizedTypography>
        )}
      </div>
      {consultingStartMethod && (
        <div className={classes.displayItem}>
          <CustomizedTypography
            className={classes.itemLabel}
            variant={'body1'}
            color="textSecondary"
            fontWeight="normal"
          >
            상담유형
          </CustomizedTypography>

          <CustomizedTypography
            variant={'body1'}
            color="textPrimary"
            fontWeight="normal"
          >
            {ConsultingStartMethodEnum[consultingStartMethod]}
          </CustomizedTypography>
        </div>
      )}
    </Box>
  );
};

export default RfqProjectInfoPresenter;
